<div class="cs-card" *ngFor="let cs of data">
    <img [src] ="cs.url"/>
    <label class="cs-type">{{ cs.subTitle }}</label>
    <label class="cs-title" [title]="cs.title">
      {{ cs.title }}
    </label>
    <p class="cs-desc">{{cs.description}}</p>
</div>
